const Clipboard = {
  setString: (text: string) => {},
};

export default Clipboard;
